import {
  REQUEST_INVITATION_LIST,
  REQUEST_INVITATION,
  REQUEST_KIOSK_INFO
} from './mutation-types';

import axiosInst from '@/utility/axiosInst';

export default {

  requestInvitationListByDaysAgo({commit}, payload) {
    const {currentPage, daysAgo} = payload
    return axiosInst.springAxiosInst.get("/invitation/get-ago-list", {
      params: {
        page: currentPage,
        daysAgo: daysAgo
      }
    }).then((res) => {
      commit(REQUEST_INVITATION_LIST, res.data)
    })
  },

  requestInvitationListByBetween({commit}, payload) {
    const {currentPage, startDate, endDate} = payload
    return axiosInst.springAxiosInst.get("/invitation/get-between-list", {
      params: {
        page: currentPage,
        startDate: startDate,
        endDate: endDate
      }
    }).then((res) => {
      commit(REQUEST_INVITATION_LIST, res.data)
    })
  },

  requestInvitation({commit}, orderNum) {
    return axiosInst.springAxiosInst.get("/invitation/get-detail", {
      params: {
        orderNum: orderNum
      }
    }).then((res) => {
      commit(REQUEST_INVITATION, res.data)
      return res.data
    })
  },

  requestKioskData({commit}, orderNum) {
    return axiosInst.springAxiosInst.get("/invitation/get-kiosk-data", {
      params: {
        orderNum: orderNum
      }
    }).then((res) => {
      if (res.data) {
        commit(REQUEST_KIOSK_INFO, res.data)
        return true
      } else {
        return false
      }
    })
  }
}